var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card raised"},[_c('div',{staticClass:"card-body"},[_c('h5',{staticClass:"card-title"},[_c('a',{attrs:{"href":"#nuk"},on:{"click":_vm.playItem}},[_vm._v(_vm._s(this.item.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }